import { cacheTypes, getMethodByCallBack, postMethodByCallBack, postMethodByDispatcher } from "../../../store/api/CommonFunctions";

export function getMessagePriorityList(onGet) {
    getMethodByCallBack("api/InterOfficeMessagesAPI/GetMessagePriorityList", cacheTypes.NoCache, onGet, "GetMessagePriorityList");
}
export function getMessageRelationTypes(onGet) {
    getMethodByCallBack("api/InterOfficeMessagesAPI/GetMessageRelationTypes", cacheTypes.NoCache, onGet, "GetMessageRelationTypes");
}
export function getLetterTemplateList(onGet) {
    getMethodByCallBack("api/InterOfficeMessagesAPI/GetLetterTemplateList", cacheTypes.NoCache, onGet, "GetLetterTemplateList");
}
export function registerInterOfficeMessage(messageID, registeredBy, registerDate, onRegister) {
    getMethodByCallBack(`api/InterOfficeMessagesAPI/RegisterInterOfficeMessage?messageID=${messageID}&regBy=${registeredBy}&regDate=${registerDate}`, cacheTypes.NoCache, onRegister, "RegisterInterOfficeMessage");
}
export function addEditInterOfficeMessage(data, onAddEdit) {
    postMethodByCallBack("api/InterOfficeMessagesAPI/AddEditInterOfficeMessage", data, onAddEdit, "AddEditInterOfficeMessage");
}
export function deleteMessage(messageID, onDelete) {
    postMethodByCallBack(`api/InterOfficeMessagesAPI/DeleteMessage`, messageID, onDelete, "DeleteMessage");
}
export function searchMessages(data) {
    return dispatch => {
        dispatch({
            type: "INTEROFFICE_MESSAGE_FILTER",
            data: data
        })
        dispatch(postMethodByDispatcher("api/InterOfficeMessagesAPI/SearchMessage", data, "SEARCH_INTEROFFICE_MESSAGE", "جستجوی مکاتبات")
        )
    }
}
export function searchMessageForSelect(number, onGet) {
    getMethodByCallBack(`api/InterOfficeMessagesAPI/SearchMessageForSelect?number=${number}`, cacheTypes.NoCache, onGet, "SearchMessageForSelect");
}
export function getMessageRealNumber(onGetNumber) {
    getMethodByCallBack("api/InterOfficeMessagesAPI/GetMessageRealNumber", cacheTypes.NoCache, onGetNumber, "GetMessageRealNumber");
}
export function getInterOfficeMessage(id, onGet) {
    getMethodByCallBack(`api/InterOfficeMessagesAPI/GetMessage?id=${id}`, cacheTypes.NoCache, onGet, "GetMessage");
}
export function AddMessageRelation(data, onAdd) {
    postMethodByCallBack(`api/InterOfficeMessagesAPI/AddMessageRelation`, data, onAdd, "AddMessageRelation");
}
export function deleteMessageRelation(id, messageID, onDelete) {
    getMethodByCallBack(`api/InterOfficeMessagesAPI/DeleteMessageRelation?id=${id}&messageID=${messageID}`, cacheTypes.NoCache, onDelete, "DeleteMessageRelation");
}
export function getMessageStatusList(onGet) {
    getMethodByCallBack(`api/InterOfficeMessagesAPI/GetMessageStatusList`, cacheTypes.NoCache, onGet, "GetMessageStatusList");
}
export function changeMessageStatus(messageID, status, onChange) {
    getMethodByCallBack(`api/InterOfficeMessagesAPI/ChangeMessageStatus?messageID=${messageID}&status=${status}`, cacheTypes.NoCache, onChange, "ChangeMessageStatus");
}